import { render, staticRenderFns } from "./SpottyWelcome.vue?vue&type=template&id=30f83914&scoped=true&"
import script from "./SpottyWelcome.vue?vue&type=script&lang=ts&"
export * from "./SpottyWelcome.vue?vue&type=script&lang=ts&"
import style0 from "./SpottyWelcome.vue?vue&type=style&index=0&id=30f83914&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f83914",
  null
  
)

export default component.exports